import { render } from "./Edit.vue?vue&type=template&id=c46f98e6"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TasksPriorities/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c46f98e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c46f98e6', __exports__)) {
    api.reload('c46f98e6', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=c46f98e6", () => {
    api.rerender('c46f98e6', render)
  })

}


export default __exports__